/** @jsx React.createElement */
import * as React from 'react';

import {panel2react} from 'common/util/react';
import {ReactSnabbdomRenderer, ReactSnabbdomRendererJsxProps} from 'common/components/react-snabbdom-renderer';

type PanelOptions = {
  jsxFactory: TODO;
  requiredProps?: string[];
  requiredParams?: string[];
};

const SnabbdomWrapper = panel2react<ReactSnabbdomRendererJsxProps>(`mp-react-snabbdom-renderer`, ReactSnabbdomRenderer);

// wc2react has rendering quirks where custom element props aren't ready inside connectedCallback() and lacks support for features like hooks.
// Wrap the target Panel component inside another Panel Component so that
// snabbdom handles the rendering, which means it can render props & params without React quirks.
// WARNING: the target Panel component will always be wrapped by an actual <mp-react-snabbdom-renderer> custom element when used in React.
export function panel2reactSnabbdomWrapper<JsxProps>(options: PanelOptions) {
  return function (props: JsxProps) {
    return (
      <SnabbdomWrapper
        targetPanelComponent={{
          ...props,
          jsxFactory: options.jsxFactory,
          requiredProps: options.requiredProps,
          requiredParams: options.requiredParams,
        }}
      />
    );
  };
}
